"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommsStatsAlerts = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<section class="comms-group-list-alert-stats row mt-3 mx-0">
    
    <div class="col-sm-6 col-lg-3 mb-3">
        <div class="card h-100 border-0 shadow-sm bg-white wa-gd-stat-card">
            <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                    ${(0, fast_element_1.when)(x => x.isGroupsMode(), (0, fast_element_1.html) `
                        <span class="text-muted small font-weight-bold d-block">${'whatsapp.dashboard.statsMonitored'.t()}</span>
                        <span class="font-weight-bold text-dark" style="font-size: 1.5rem;">${x => x.itemCount}</span>
                        <span class="text-success small font-weight-bold d-block mt-1">${'whatsapp.groups.tracking'.t()}</span>
                    `)}
                    ${(0, fast_element_1.when)(x => x.isDirectMessagesMode(), (0, fast_element_1.html) `
                        <span class="text-muted small font-weight-bold d-block">${'whatsapp.dm.stats.contacts'.t()}</span>
                        <span class="font-weight-bold text-dark" style="font-size: 1.5rem;">${x => x.itemCount}</span>
                        <span class="text-success small font-weight-bold d-block mt-1">${'whatsapp.dm.stats.total'.t()}</span>
                    `)}
                    ${(0, fast_element_1.when)(x => x.isEmailMode(), (0, fast_element_1.html) `
                        <span class="text-muted small font-weight-bold d-block">${'whatsapp.email.stats.contacts'.t()}</span>
                        <span class="font-weight-bold text-dark" style="font-size: 1.5rem;">${x => x.itemCount}</span>
                        <span class="text-success small font-weight-bold d-block mt-1">${'whatsapp.email.stats.total'.t()}</span>
                    `)}
                </div>
                <div class="stat-icon-circle ${x => x.isGroupsMode() ? 'success' : (x.isDirectMessagesMode() ? 'primary' : 'info')}">
                    <i class="${x => x.isGroupsMode() ? 'iconsminds-speach-bubbles' : (x.isDirectMessagesMode() ? 'iconsminds-male-female' : 'iconsminds-envelope')}"></i>
                </div>
            </div>
        </div>
    </div>

    
    <div class="col-sm-6 col-lg-3 mb-3">
        <div class="card h-100 border-0 shadow-sm bg-white wa-gd-stat-card">
            <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                    <span class="text-muted small font-weight-bold d-block">${'whatsapp.dashboard.statsCritical'.t()}</span>
                    <span class="font-weight-bold text-danger" style="font-size: 1.5rem;">${x => x.criticalCount}</span>
                    <span class="text-danger small font-weight-bold d-block mt-1">${'whatsapp.dashboard.filterCritical'.t()}</span>
                </div>
                <div class="stat-icon-circle danger">
                    <i class="iconsminds-danger"></i>
                </div>
            </div>
        </div>
    </div>

    
    <div class="col-sm-6 col-lg-3 mb-3">
        <div class="card h-100 border-0 shadow-sm bg-white wa-gd-stat-card">
            <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                    <span class="text-muted small font-weight-bold d-block">${'whatsapp.dashboard.filterWarning'.t()}</span>
                    <span class="font-weight-bold text-warning" style="font-size: 1.5rem;">${x => x.warningCount}</span>
                    <span class="text-warning small font-weight-bold d-block mt-1">${'whatsapp.dashboard.aiStatus.warning'.t()}</span>
                </div>
                <div class="stat-icon-circle warning">
                    <i class="iconsminds-danger"></i>
                </div>
            </div>
        </div>
    </div>

    
    <div class="col-sm-6 col-lg-3 mb-3">
        <div class="card h-100 border-0 shadow-sm bg-white wa-gd-stat-card">
            <div class="card-body d-flex align-items-center justify-content-between">
                <div>
                    <span class="text-muted small font-weight-bold d-block">${'whatsapp.dashboard.statsStatus'.t()}</span>
                    <span class="font-weight-bold small mt-1 d-block">
                        <span class="text-success">${x => x.statusGoodCount} Ok</span> •
                        <span class="text-warning">${x => x.statusWarningCount} ${'whatsapp.dashboard.aiStatus.warning'.t()}</span> •
                        <span class="text-secondary">${x => x.statusNeutralCount} ${'whatsapp.dashboard.aiStatus.neutral'.t()}</span>
                    </span>
                    <span class="text-muted small d-block mt-1">${'whatsapp.dashboard.aiStatus.good'.t()}</span>
                </div>
                <div class="stat-icon-circle success">
                    <i class="iconsminds-statistic"></i>
                </div>
            </div>
        </div>
    </div>
</section>`;
require("./styles/layout.scss");
const styles = T.css `.wa-groups-dashboard {
  display: flex;
  height: calc(100vh - 200px);
  min-height: 500px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
}

.wa-gd-sidebar {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #d7d7d7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wa-gd-sidebar-header {
  flex-shrink: 0;
}

.wa-gd-search {
  padding-left: 30px !important;
  border: 1px solid #d7d7d7 !important;
}

.wa-gd-filter-btn {
  flex: 1;
  padding: 5px 4px;
  border: 1px solid #d7d7d7;
  background: #f5f6f8;
  color: #333;
  font-size: 0.72rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.12s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.wa-gd-filter-btn:first-child {
  border-radius: 4px 0 0 4px;
}
.wa-gd-filter-btn:last-child {
  border-radius: 0 4px 4px 0;
  border-left: none;
}
.wa-gd-filter-btn:not(:first-child) {
  border-left: none;
}
.wa-gd-filter-btn:hover {
  background: #ececec;
}
.wa-gd-filter-btn.active {
  background: #3b82f6;
  color: #fff;
  font-weight: 700;
  border-color: #2563eb;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}
.wa-gd-filter-btn.active .wa-gd-count {
  color: rgba(255, 255, 255, 0.8);
}

.wa-gd-count {
  font-weight: normal;
  color: #888;
  font-size: 0.68rem;
}

.wa-gd-sidebar-list {
  flex: 1;
  overflow-y: auto;
}

.wa-gd-sidebar-item {
  display: block;
  width: 100%;
  padding: 11px 14px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.12s ease;
}
.wa-gd-sidebar-item:hover {
  background: #f5f5f5;
}

.wa-gd-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
}

.wa-gd-sidebar-footer {
  flex-shrink: 0;
}

.wa-gd-center {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
}

.wa-gd-stat-card {
  padding-top: 0 !important;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.wa-gd-messages-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wa-gd-messages-panel .card-header {
  flex-shrink: 0;
}

.wa-gd-messages-body {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 440px;
  background: #f8f9fa;
}

.wa-gd-msg-list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 6px;
}

.wa-gd-msg-item {
  background: #fff;
  border-radius: 6px;
  padding: 7px 10px;
  border: 1px solid #e9ecef;
  font-size: 0.82rem;
  line-height: 1.4;
}
.wa-gd-msg-item .wa-gd-msg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}
.wa-gd-msg-item .wa-gd-msg-sender {
  font-weight: 600;
  color: #28a745;
}
.wa-gd-msg-item .wa-gd-msg-time {
  color: #adb5bd;
  font-size: 0.72rem;
  margin-left: auto;
  flex-shrink: 0;
}
.wa-gd-msg-item .wa-gd-msg-body {
  color: #343a40;
  word-break: break-word;
}

.wa-gd-tracklogs-section {
  background: #fff;
}

.wa-gd-tracklogs-header {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa !important;
}

.wa-gd-tracklogs-list {
  overflow-y: auto;
}

.wa-gd-tracklog-item {
  font-size: 0.8rem;
  background: #fff;
  transition: all 0.12s ease;
}
.wa-gd-tracklog-item:last-child {
  border-bottom: none !important;
}
.wa-gd-tracklog-item:hover {
  background: #f8f9fa;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.loading_groups {
  margin-top: 50px;
  text-align: center;
  color: #888;
}

.whatsapp-dm-detail {
  width: 100%;
}
.whatsapp-dm-detail .top-right-button-container {
  float: right;
}

.comms-group-list-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.comms-group-list-header h1 {
  margin-bottom: 0;
}

.comms-group-list-actions {
  flex-shrink: 0;
}

.comms-group-list-contact-info {
  padding-top: 0 !important;
}

.comms-group-list-summaries {
  padding-top: 0 !important;
}

.comms-group-list-messages {
  padding-top: 0 !important;
  display: flex;
  flex-direction: column;
}

.comms-group-list-messages-controls {
  flex-shrink: 0;
}

.comms-group-list-messages-list {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 500px;
}

.comms-group-list-send-message {
  padding-top: 0 !important;
}

.comms-group-list-members {
  padding-top: 0 !important;
}

.comms-group-list-add-participants {
  padding-top: 0 !important;
}

.comms-group-list-bot-settings {
  padding-top: 0 !important;
}

.card {
  padding-top: 1.5rem;
}

.summary-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1040;
}

.summary-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  background: #fff;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767.98px) {
  .summary-drawer {
    width: 100vw;
  }
}

.summary-drawer-body {
  overflow-y: auto;
  flex: 1;
}

.messages-list {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.messages-list .message-item:nth-child(odd) {
  background-color: rgb(243, 243, 243) !important;
}

.message-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.message-item:last-child {
  border-bottom: none;
}
.message-item--agent {
  background-color: #e8f5e9 !important;
}
.message-item__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.message-item__sender {
  font-weight: 600;
  font-size: 0.85rem;
  color: #333;
}
.message-item__time {
  font-size: 0.75rem;
  color: #999;
}
.message-item__body {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
  word-break: break-word;
}
.message-item__media {
  margin-top: 8px;
}

.text-muted-small {
  font-size: 0.72rem;
  color: #888;
}

.text-truncate-max {
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-comms-type {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-type.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-type.tele {
  background-color: #0088cc;
  color: #fff;
}

.badge-tracking {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.join-group-hint {
  color: #666;
  font-size: 0.9rem;
}

.join-group-modal-body {
  padding: 8px 0;
}

.wa-green-text {
  color: #25d366 !important;
}

.info-text {
  color: #17a2b8 !important;
}

.primary-text {
  color: #3b82f6 !important;
}

.success-text {
  color: #28a745 !important;
}

.warning-text {
  color: #ffc107 !important;
}

.danger-text {
  color: #dc3545 !important;
}

.text-secondary {
  color: #555 !important;
}

.contact-info-card-primary {
  background: #f0f9ff;
  border: 1px solid #bee3f8;
}
.contact-info-card-primary strong {
  font-size: 1.05rem;
  color: #1a1a2e;
}

.contact-info-card-secondary {
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
}

.font-monospace {
  font-family: monospace;
}

.word-break-all {
  word-break: break-all;
}

.summaries-table th {
  white-space: nowrap;
}

.stat-icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.stat-icon-circle.success {
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.25);
  color: #28a745;
}
.stat-icon-circle.danger {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.25);
  color: #dc3545;
}
.stat-icon-circle.warning {
  background-color: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.25);
  color: #ffc107;
}
.stat-icon-circle.primary {
  background-color: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.25);
  color: #3b82f6;
}
.stat-icon-circle.info {
  background-color: rgba(23, 162, 184, 0.1);
  border: 1px solid rgba(23, 162, 184, 0.25);
  color: #17a2b8;
}

.sidebar-item-content {
  min-width: 0;
  flex: 1;
}
.sidebar-item-content .item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  gap: 8px;
}
.sidebar-item-content .item-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.sidebar-item-content .item-badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}
.sidebar-item-content .item-status {
  display: flex;
  align-items: center;
  gap: 3px;
}
.sidebar-item-content .status-dot-sm {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.sidebar-item-content .status-label {
  font-size: 0.68rem;
  font-weight: 600;
}
.sidebar-item-content .item-comment {
  font-size: 0.72rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.badge-tracking-sm {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.badge-comms-sm {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-sm.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-sm.tele {
  background-color: #0088cc;
  color: #fff;
}
.badge-comms-sm.email {
  background-color: var(--primary-color);
  color: #fff;
}

.badge-count-sm {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #6c757d;
  color: #fff;
}

.badge-count-info {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #17a2b8;
  color: #fff;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.wa-gd-tracklog-badge.critical {
  background-color: #dc3545;
  color: #fff;
}
.wa-gd-tracklog-badge.warning {
  background-color: #ffc107;
  color: #212529;
}
.wa-gd-tracklog-badge.good {
  background-color: #28a745;
  color: #fff;
}
.wa-gd-tracklog-badge.neutral {
  background-color: #6c757d;
  color: #fff;
}

.card-header-icon {
  margin-right: 0.5rem;
}
.card-header-icon.success {
  color: #28a745;
}
.card-header-icon.primary {
  color: #3b82f6;
}
.card-header-icon.info {
  color: #17a2b8;
}
.card-header-icon.wa-green {
  color: #25d366;
}

.tracklog-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
}

.tracklog-summary {
  font-size: 0.75rem;
  line-height: 1.4;
  color: #888;
}

.tracklog-timestamp {
  font-size: 0.7rem;
  color: #888;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.tracklog-group-name {
  font-size: 0.7rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tracklog-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.tracklog-header-actions {
  display: flex;
  gap: 6px;
}

.card-header-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0;
}

.handler-switch {
  display: inline-flex;
  align-items: center;
}

:host {
  display: block;
  width: 100%;
}`;
const shadowOptions = { "mode": "open" };
let CommsStatsAlerts = class CommsStatsAlerts extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.mode = 'groups'; // 'groups' | 'directMessages' | 'email'
        this.trackLogs = [];
        this.items = [];
        this.criticalCount = 0;
        this.warningCount = 0;
        this.itemCount = 0;
        this.statusGoodCount = 0;
        this.statusWarningCount = 0;
        this.statusNeutralCount = 0;
    }
    trackLogsChanged() {
        this.updateCounts();
    }
    itemsChanged() {
        this.updateCounts();
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateCounts();
    }
    getItemId(item) {
        if (this.mode === 'groups')
            return item.id || '';
        if (this.mode === 'email')
            return item.emailAddress || '';
        return item.authorLid || '';
    }
    getTrackLogItemId(log) {
        if (this.mode === 'groups')
            return log.groupId || '';
        return log.authorLid || '';
    }
    getLatestLogType(itemId) {
        const idField = this.mode === 'groups' ? 'groupId' : 'authorLid';
        const logs = this.trackLogs.filter(l => l[idField] === itemId);
        if (!logs.length)
            return null;
        const unhandled = logs.filter(l => !l.isHandled);
        if (!unhandled.length)
            return backendImport_1.TrackLogType.Neutral;
        const priority = [backendImport_1.TrackLogType.Critical, backendImport_1.TrackLogType.Warning, backendImport_1.TrackLogType.Good, backendImport_1.TrackLogType.Neutral];
        for (const type of priority) {
            if (unhandled.some(l => l.logType === type))
                return type;
        }
        return unhandled[0].logType || null;
    }
    updateCounts() {
        const logs = this.trackLogs || [];
        const items = this.items || [];
        // Critical and warning counts from unhandled track logs
        this.criticalCount = logs.filter(l => !l.isHandled && l.logType === 'critical').length;
        this.warningCount = logs.filter(l => !l.isHandled && l.logType === 'warning').length;
        // Item count
        if (this.mode === 'groups') {
            this.itemCount = items.filter(g => g.tracking).length;
        }
        else {
            this.itemCount = items.length;
        }
        // Status breakdown per item
        this.statusGoodCount = items.filter(item => this.getLatestLogType(this.getItemId(item)) === 'good').length;
        this.statusWarningCount = items.filter(item => this.getLatestLogType(this.getItemId(item)) === 'warning').length;
        this.statusNeutralCount = items.filter(item => {
            const status = this.getLatestLogType(this.getItemId(item));
            return !status || status === 'neutral';
        }).length;
    }
    isGroupsMode() {
        return this.mode === 'groups';
    }
    isDirectMessagesMode() {
        return this.mode === 'directMessages';
    }
    isEmailMode() {
        return this.mode === 'email';
    }
};
exports.CommsStatsAlerts = CommsStatsAlerts;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsStatsAlerts.prototype, "mode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CommsStatsAlerts.prototype, "trackLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CommsStatsAlerts.prototype, "items", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "criticalCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "warningCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "itemCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "statusGoodCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "statusWarningCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CommsStatsAlerts.prototype, "statusNeutralCount", void 0);
exports.CommsStatsAlerts = CommsStatsAlerts = __decorate([
    (0, client_1.RWSView)('comms-stats-alerts', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], CommsStatsAlerts);
CommsStatsAlerts.defineComponent();
